import { JSX } from 'solid-js';
import { t } from '@trimble/i18n';
import { Spinner } from '@tcweb/connect-ui';

export interface LoadingStateProps {
  /** Size of the spinner - defaults to 'small' */
  size?: 'small' | 'medium' | 'large';
  /** Custom loading text - defaults to 'general.loading' */
  text?: string;
  /** Whether to show text alongside spinner - defaults to true */
  showText?: boolean;
  /** Additional CSS classes */
  class?: string;
  /** Whether to use inline layout - defaults to false */
  inline?: boolean;
}

/**
 * Standardized loading component with Modus spinner and optional text
 */
export function LoadingState(props: Readonly<LoadingStateProps>): JSX.Element {
  const showText = (): boolean => props.showText ?? true;
  const text = (): string => props.text ?? t('general.loading');
  const inline = (): boolean => props.inline ?? false;

  return (
    <div
      class={`${
        inline() ? 'inline-flex items-center gap-2' : 'flex items-center gap-2'
      } ${props.class ?? ''}`}
    >
      <Spinner show={true} />
      {showText() && <span>{text()}</span>}
    </div>
  );
}

/**
 * Error state component
 */
export interface ErrorStateProps {
  error?: Error | string;
  prefix?: string;
  class?: string;
}

export function ErrorState(props: Readonly<ErrorStateProps>): JSX.Element {
  const errorMessage = (): string => {
    if (typeof props.error === 'string') return props.error;
    return props.error?.message ?? t('general.error');
  };

  const prefix = (): string => props.prefix ?? t('general.error');

  return (
    <p class={`text-red-500 ${props.class ?? ''}`}>
      {prefix()}: {errorMessage()}
    </p>
  );
}
